import { ContactFieldValidType } from "./types"

export function isEmpty(obj?: any) {
    return obj === null || obj === undefined || (typeof obj === 'string' ? obj === '' : false) || String(obj) === 'null' || String(obj) === 'undefined'
}

export const slugify = (value: string) => value.toLowerCase().replace(/\W+/g, " ").trim().replace(/ +/g, "-").replace(/-+/g, "-")

export const PHONE_REGEX = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/

// RFC 5322 Official Standard email regex
// * modified to add uppercase letters (A-Z)
// eslint-disable-next-line no-control-regex, no-useless-escape
export const GENERAL_EMAIL_REGEX = /(?:[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const getDefaultInputMaxLength = (type: ContactFieldValidType) => {
    switch (type) {
        case 'email':
            return 320
        case 'phone':
            return 40
        case 'textarea':
            return 2000
        case 'text':
        default:
            return 200
    }
}

export const phoneMask = {
    mask: '(#00) 000-0000',
    definitions: {
        '#': /[1-9]/,
    }
}

export function getUrlQuery(key: string) {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(key)
}

export const defaultReferral = 'cyber411'

export function validateHexCode(code: string) {
    return /(^#[0-9A-F]{3,4}$)|(^#[0-9A-F]{6}$)|(^#[0-9A-F]{8}$)/i.test(code)
}
